export default "__VITE_ASSET__DhNxWDX1__"